import React, { useState, useEffect } from 'react';
import {  useHistory } from "react-router-dom";
import axios from 'axios'
import swal from 'sweetalert'
export default function Login(props) {
    const [username, setusername] = useState("");
    const [password, setpassword] = useState("");
    const [loading, setloading] = useState(false);
   

    const validateuser = async (username, password) => {
        
        try {
            let url = process.env.REACT_APP_APIURL + "user/validateuser?username=" + username + "&password=" + password
            let json = await axios.get(url)
            if (json.status === 200) {
                localStorage.setItem("companyname", json.data.company_id)
                localStorage.setItem("Username", json.data.f_name)
                localStorage.setItem("usertypeid", json.data.usertypeid)
                localStorage.setItem("userTypename", json.data.userTypename)
                localStorage.setItem("userid", json.data.id)
                localStorage.setItem("logo", json.data.image)
                localStorage.setItem("minlogo", json.data.image1)
                props.isauth(true)
               
               // history.push('/')
            }

        }
        catch (ex) {
            // console.log(ex)
            swal({
                title: ";(",
                text: "Invalid username or password"
            })
        }
        setloading(false)
    }

    const handlesubmit = async (e) => {
        e.preventDefault();
        setloading(true)
        validateuser(username, password)
    }
    return (
        <>
            <div className="authincation h-100">
                <div className="container h-100">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className="col-md-6">
                            <div className="authincation-content">
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className="auth-form">
                                            <h4 className="text-center mb-4">Sign in</h4>
                                            <form id="form" onSubmit={handlesubmit}>
                                                <div className="mb-3">
                                                    <label className="mb-1"><strong>Username</strong></label>
                                                    <input type="text" className="form-control" id="email"
                                                        placeholder="Enter your Username" value={username} onChange={(e) => { setusername(e.target.value) }} required />
                                                    <small></small>
                                                </div>
                                                <div className="mb-3">
                                                    <label className="mb-1"><strong>Password</strong></label>
                                                    <input type="password" className="form-control" id="password" placeholder="Password" value={password} onChange={(e) => { setpassword(e.target.value) }} required />
                                                    <small></small>
                                                </div>
                                                <div className="text-center">
                                                    <button type="submit" className="btn btn-primary btn-block" disabled={loading} >{loading ? "Loading..." : "Sign In"}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}